import React from 'react';
import styled from 'styled-components';
import { string, func } from 'prop-types';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const hourlyIcon = `${CDN_URL}storage/Storage-hourly-graph-selector.svg`;
//const hourlyIconSelected = `${CDN_URL}storage/Storage-hourly-graph-selector-selected.svg`;
const dailyIcon = `${CDN_URL}storage/Storage-daily-graph-selector.svg`;
//const dailyIconSelected = `${CDN_URL}storage/Storage-daily-graph-selector-selected.svg`;
const monthlyIcon = `${CDN_URL}storage/Storage-monthly-graph-selector.svg`;
//const monthlyIconSelected = `${CDN_URL}storage/Storage-monthly-graph-selector-selected.svg`;

const Toggle = styled.div`
	display: flex;
	//border: 1px solid blue;
	width: 225px;
	.toggle-option {
		display: flex;
		height: 20px;
		cursor: pointer;
		justify-content: center;
		align-items: center;
		width: 75px;
		//border: 1px solid green;
		img {
			width: 10px;
			height: 10px;
			margin-right: 5px;
		}
		.toggle-text {
			text-transform: capitalize;
			color: ${props => props.theme.defaultFontColor};
		}
		&.selected {
			background: ${props => props.theme.white};
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		width: 255px;
		.toggle-option {
			height: 24px;

			width: 85px;

			img {
				width: 15px;
				height: 15px;
				margin-right: 5px;
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 300px;
		.toggle-option {
			height: 32px;

			width: 100px;

			img {
				width: 15px;
				height: 15px;
				margin-right: 5px;
			}
		}
	}
`;

function getImage(name) {
	switch (name) {
		case 'hourly':
			return hourlyIcon;

		case 'daily':
			return dailyIcon;

		case 'monthly':
			return monthlyIcon;
		default:
			return hourlyIcon;
	}
}

// function getImageSelected(name) {
// 	switch (name) {
// 		case 'hourly':
// 			return hourlyIconSelected;
// 		case 'daily':
// 			return dailyIconSelected;

// 		case 'monthly':
// 			return monthlyIconSelected;
// 		default:
// 			return hourlyIconSelected;
// 	}
// }

export const ToggleButtonNew = ({
	className,
	id,
	onClick,
	cypressId,
	module,
	selected,
	options,
}) => {
	return (
		<Toggle id={`${id}`} className={`${className}`} data-cy={cypressId} module={module}>
			{options.map(option => (
				<div
					className={selected === option ? `toggle-option selected` : `toggle-option`}
					onClick={() => onClick(option)}
				>
					<img src={getImage(option)} />
					<div className='toggle-text body10'>{option} </div>
				</div>
			))}
		</Toggle>
	);
};

ToggleButtonNew.propTypes = {
	className: string,
	id: string,
	onClick: func,
	cypressId: string,
	module: string,
};

ToggleButtonNew.defaultProps = {
	className: '',
	id: '',
	onClick: () => {},
	cypressId: '',
	module: 'support',
};
